import React, {useEffect, useState} from 'react';
import Submenu from 'components/Navigation/Submenu/Submenu';
import Panel from 'components/UI/Panel/Panel';
import {useTranslation} from 'react-i18next';
import Search from 'components/UI/Panel/Search/Search';
import classes from './ClubCoaches.module.scss';
import {useReactiveVar} from '@apollo/client';
import {naviDataVar} from 'apollo/cashe';
import cn from 'classnames';
import Subtext from 'components/UI/Table/Subtext/Subtext';
import Table from 'components/UI/Table/Table';
import Pagination from 'components/UI/Pagination/Pagination';
import Button from 'components/UI/Button/Button';
import StaffForm from '../Access/forms/StaffForm';
import {useArchiveTrainer, useClubCoaches} from 'apollo/queries/TrainerQueries';
import ModalWindow2, {ModalState} from 'components/UI/ModalWindow/ModalWindow2';
import ShowDate from 'components/UI/DatePicker/ShowDate';
import {SystemRoles} from 'components/Navigation/CanAccess/roles';
import CanAccess from 'components/Navigation/CanAccess/CanAccess';

const ClubCoaches = (props) => {
    const {t} = useTranslation();
    const navState = useReactiveVar(naviDataVar);
    const onPage = 20;

    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);

    const {data, loading, error, refetch}  = useClubCoaches({
        clubId: navState.clubId,
        search: search,
        take: onPage,
        skip: skip * onPage,
    });

    const [modalData, setModalData, initState] = ModalState();
    const [archiveTrainer] = useArchiveTrainer();

    const onAddClick = () => {
        const data = {
            ...initState,
            title: t("Add new coach"),
            pages: {
                page: 0,
                maxPages: 3,
            },
            styles: {
                maxWidth: "700px",
            },
            defaultValues: {
                isTrainer: true,
                isTrainerDisabled: true
            },
            onComplete: onComplete,
            open: true
        }
        setModalData(data);
    }

    const onArchiveClick = async () => {
        selectedRows.forEach(row => {
            const variables = {
                input: {
                    id: row.trainerId,
                    clubId: navState.clubId,
                }
            };

            archiveTrainer({variables: variables}).then((result) => {
                if (result) {
                    refetch();
                }
            });
        });
    }

    const actions = () => (
      <CanAccess users={[SystemRoles.SysAdmin, SystemRoles.ClubAdmin]}>
        <Button type="primary" style={{margin: 0}} onClick={onAddClick}>
            <span><i className="icon-Plus-Square"></i> {t('Add coach')}</span>
        </Button>

        {selectedRows.length > 0 &&
            <Button type="secondary" style={{margin: 0}} onClick={onArchiveClick}>
                <span>{t('Archive')}</span>
            </Button>
        }
      </CanAccess>
    );

    const onSearch = (e) => {
        setSkip(0);
        setSearch(e.target.value);
    }

    const panelSearch = () => (
        <Search onSearch={onSearch} placeholder={t("Search coach...")} />
    );

    const onEdit = (data) => {

        const _data = {
            ...initState,
            title: t("Add new coach"),
            access: [SystemRoles.SysAdmin, SystemRoles.ClubAdmin],
            pages: {
                page: 0,
                maxPages: 3,
            },
            styles: {
                maxWidth: "700px",
            },
            defaultValues: {
                ...data
            },
            onComplete: onComplete,
            open: true
        }
        setModalData(_data);
    }

    const onComplete = () => {
        setModalData({...initState});
        refetch();
    };

    const onAssign = () => {

    }

    return (
        <>
            <div className={cn('page-header', classes.coaches)}>
                <div className={classes.name}>{navState.clubName}</div>
                <h2>{t('Coaches')}</h2>
                <Submenu />
            </div>
            <div className="page-content">
                <Panel border={false} action={actions} search={panelSearch}>
                    <br />
                </Panel>

                {loading && <>Loading...</>}
                {error && <>Error...</>}

                {data ?
                    <>
                        <Table
                            data={data.trainers.items}
                            access={[SystemRoles.SysAdmin, SystemRoles.ClubAdmin]}
                            columns={[
                                {
                                    Header: t('Coach'),
                                    accessor: 'fullName',
                                    Cell: (cellData) => {
                                        const {certification, certificationEndDate} = cellData.row.original;
                                        return (<div onClick={() => onEdit(cellData.row.original)}>
                                            {cellData.value}
                                            <Subtext>
                                                {t("Certification")}:
                                                {certification ? <> {certification}
                                                    {certificationEndDate ? <>, <ShowDate date={certificationEndDate} /></>
                                                        : undefined }</> : " -"}
                                            </Subtext>
                                        </div>)
                                    }
                                },
                                {
                                    Header: t('Contacts'),
                                    accessor: 'email',
                                    Cell: (cellData) => {
                                        const email = cellData.value;
                                        const phone = cellData.row.original.phoneNumber;
                                        return (<>
                                            <a href={`mailto:${email}`}>{email}</a>
                                            <Subtext>
                                                {t("Phone")}: {phone ? <a href={`phone:${phone}`}>{phone}</a> : "-"}
                                            </Subtext>
                                        </>);
                                    }
                                },
                                {
                                    Header: t('Teams'),
                                    accessor: 'teams',
                                    Cell: (cellData) => {
                                        const {trainerId} = cellData.row.original;
                                        return (cellData.row.original.teams.map((x, index) =>
                                            <span key={`team-${trainerId}-${x.team.name}`}>
                                                {(index ? ', ' : '')} {x.team.name}
                                            </span>
                                        ));
                                    }
                                }
                            ]}
                            onSelectClick={(x) => setSelectedRows(x)}
                            onRowClick={() => {}}
                        />

                        <Pagination page={skip} count={data.trainers.totalCount} onPage={onPage}
                                    onPageChange={(p) => setSkip(p.selected)}/>
                    </>
                    :undefined
                }
            </div>

            <ModalWindow2 {...modalData}>
                <StaffForm {...modalData} name="staff" />
            </ModalWindow2>
        </>
    );
};

ClubCoaches.defaultProps = {
    options: [
        {label: "Select from staff", value: "select"},
        {label: "Add new employer", value: "addNew"},
    ]
};

export default ClubCoaches;

